import Keycloak from 'keycloak-js';
import { fetchUtils } from 'react-admin';
import { TokenProvider, getAppContextHeaders } from '../../app/app.context.provider';

/**
 * The httpClient which adds headers needed by Keycloak in all requests.
 * @param keycloak the client for the Keycloak authentication server.
 * @returns a function with the same definition as `httpClient`, which adds headers needed by Keycloak in all requests.
 */
/*
export const httpClient = (keycloak: Keycloak) => (
    url: any,
    options: fetchUtils.Options | undefined
) => {
    const requestHeaders = getKeycloakHeaders(url, keycloak.token, options);
    return fetchUtils.fetchJson(url, {
        ...options,
        headers: requestHeaders,
    });
};
*/
export const httpClient = (keycloak: Keycloak) => async (
  url: any,
  options: fetchUtils.Options = {}
) => {
  try {
      // Attempt to refresh the token if it's valid for less than 30 seconds
      const refreshed = await keycloak.updateToken(30);
      const requestHeaders = getKeycloakHeaders(url, keycloak.token, options);

      // Proceed with the request
      return fetchUtils.fetchJson(url, {
          ...options,
          headers: requestHeaders,
      });
  } catch (error) {
      console.error('Failed to refresh token', error);
      // Handle token refresh failure, e.g., redirect to login
      keycloak.login();
      return Promise.reject('Failed to refresh token');
  }
};


/**
 * Return the headers needed by Keycloak.
 * @param token the Keycloak token
 * @param options the fetch options (so that we do not override other headers)
 * @returns the headers needed by Keycloak
 */
export const getKeycloakHeaders = (
  url: string,
  token: string | null,
  options?: fetchUtils.Options
): Headers => {
  // wrap whatever we got in a real Headers instance
  const headers = new Headers(options?.headers);

  // make sure Accept is present; you can skip if it’s already there
  if (!headers.has('Accept')) {
    headers.set('Accept', 'application/json');
  }

  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  getAppContextHeaders(url, headers);
  return headers;
};

/*export const getTokenProvider = (
    keycloak: Keycloak
  ): TokenProvider => {
    return {
      getIdToken: async () => {
        return keycloak.token;
      },
    };
  }
    */
  export const getTokenProvider = (keycloak: Keycloak): TokenProvider => {
    return {
      getIdToken: async () => {
        try {
          // Attempt to refresh the token if it's valid for less than 30 seconds
          const refreshed = await keycloak.updateToken(30);
          if (refreshed) {
            console.log('Token was successfully refreshed');
          } 
          return keycloak.token;
        } catch (error) {
          console.error('Failed to refresh token', error);
          // Handle token refresh failure, e.g., redirect to login
          keycloak.login();
          return null;
        }
      },
    };
  };